/* 密码验证 */
/**
 * @param {String} userpass 需要验证密码
 * @roles 8-20位字符，须包含数字、大小写字母、特殊符号三种组合
 * @returns {Boolean} 返回布尔值
 */
export function userPassReg(userPass) {
  if (userPass === '') return
  if(!/((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,20}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,20}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,20}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,20}$))/.test(userPass)){
    return false
  } else { return true }
}

/* 手机号验证 */
/**
 * @param {String | Number} userPhone 手机号码
 * @returns {Boolean} 布尔值
 */
export function phoneReg(userPhone) {
  if (userPhone === '') return
  if(!/^1[3456789]\d{9}$/.test(userPhone)) {
    return false
  } else { return true }
}

/* 身份证号码验证 */
/**
 * @param {string | Number} idCard 身份证号码
 * @returns {Boolean} 布尔值
 */
export function IDcardReg(idCard) {
  if (idCard === '') return
  if(!/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(idCard)) {
    return false
  } else { return true }
}
